import React from "react";
import PropTypes from "prop-types";
import { pipe, partial } from "ramda";

import Input from "components/input";

import { getTargetValue } from "helpers/event";
import { handleErrors } from "helpers/credit_cards";

function CvvValidation({ card, onCvvUpdate, onBlurValidateField }) {
  return (
    <div className="form">
      <div className="row">
        <label>CVV</label>
        <Input
          id="cvv-validation-cvv"
          error={handleErrors("cvv", card)}
          onBlur={partial(onBlurValidateField, ["cvv", card])}
          type="text"
          autoComplete="cc-csc"
          maxLength="4"
          value={card.cvv}
          required
          onChange={pipe(getTargetValue, partial(onCvvUpdate, [card.cardUuid]))}
        />
      </div>
    </div>
  );
}

CvvValidation.propTypes = {
  card: PropTypes.shape({
    cardUuid: PropTypes.string,
  }).isRequired,
  onCvvUpdate: PropTypes.func.isRequired,
  onBlurValidateField: PropTypes.func.isRequired,
};

export default CvvValidation;
